import Router from "vue-router";
import axios from "./interceptor";
import { api } from "./models/api-path.model";

const loadView = (view: any) => {
  return () => import(`@/views/${view}.vue`);
};

function moveToLogin(message: string, next: any) {
  alert(message);
  window.localStorage.clear();
  next({ path: "/" });
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Login",
      component: loadView("Login")
    },
    {
      path: "*",
      name: "NotFound",
      component: loadView("Login")
    },
    {
      path: "/park-list",
      name: "ParkList",
      component: loadView("ParkList")
    },
    {
      path: "/park-detail/:id",
      name: "ParkDetail",
      component: loadView("ParkDetail")
    },
    {
      path: "/business-sheet/:id",
      name: "BusinessSheet",
      component: loadView("BusinessSheet")
    },
    {
      path: "/business-status",
      name: "BusinessStatus",
      component: loadView("BusinessStatus")
    },
    {
      path: "/park-regist",
      name: "ParkRegist",
      component: loadView("ParkDetail")
    },
    {
      path: "/manual",
      name: "Manual",
      component: loadView("Manual"),
      children: [
        // 탭 메뉴 작업을 위하여 하위메뉴를 설정할 수 있습니다.
        {
          path: "",
          redirect: "/manual/manualpagef"
        },
        {
          path: "manualpagef",
          name: "ManualPageF",
          component: loadView("ManualPageF")
        },
        {
          name: "manualpaget",
          path: "ManualPageT",
          component: loadView("ManualPageT")
        }
      ]
    },
    {
      path: "/park-admin",
      name: "ParkAdmin",
      component: loadView("ParkAdmin"),
      children: [
        // 탭 메뉴 작업을 위하여 하위메뉴를 설정할 수 있습니다.
        {
          path: "",
          redirect: "/park-admin/adminstats"
        },
        {
          // 주차장 통계 페이지
          path: "adminstats",
          name: "AdminStats",
          component: loadView("AdminStats")
        },
        {
          // 주차장 목록 페이지
          name: "adminlist",
          path: "AdminList",
          component: loadView("AdminList")
        }
      ]
    },
    {
      path: "/pw-change",
      name: "PwChange",
      component: loadView("PwChange")
    },
    {
      path: "/join",
      name: "Join",
      component: loadView("Join")
    }
  ]
});

router.beforeEach((to, from, next) => {
  const path = to.name;

  switch (path) {
    case null:
    case "Login":
    case "Join":
    case "NotFound": {
      next();
      break;
    }

    default: {
      axios
        .get(api.sessionCheck)
        .then(async ({ data: { data, error }, status }) => {
          if (status !== 200) {
            alert(
              "서버 상태가 원활하지 않습니다.\n잠시 후에 다시 시도해주세요."
            );
            return;
          }

          if (error) {
            try {
              const isAutoLogin = window.localStorage.getItem("isAutoLogin");

              if (isAutoLogin) {
                const id = window.localStorage.getItem("id");
                const passwd = window.localStorage.getItem("passwd");
                const {
                  data: { data, code, error }
                } = await axios.post(api.signIn, { id, passwd });

                if (error) {
                  moveToLogin(
                    "회원 정보가 일치하지 않습니다.\n로그인 화면으로 이동합니다.",
                    next
                  );
                }

                if (code === 20000) {
                  window.localStorage.setItem("jwt", data.jwt);
                  next();
                }
                return;
              }
            } catch (e) {
              moveToLogin(
                "회원 정보가 일치하지 않습니다.\n로그인 화면으로 이동합니다.",
                next
              );
              return;
            }

            moveToLogin(
              "세션 정보를 찾을 수 없습니다.\n로그인 화면으로 이동합니다.",
              next
            );
            return;
          }

          if (data) {
            next();
            return;
          }

          next();
        })
        .catch(error => next({ path: "/" }))
    }
  }
});

export default router;
